export function noop() { /** no-op */ }
